export default __webpack_public_path__ + "static/media/b1.87490575.jpg";